import axios from 'axios';

const api = axios.create({ baseURL: 'https://api.tigerdesk.me/api/v1.0'});

export default api;